import React from 'react';

import Paper from '@material-ui/core/Paper';

import * as classes from './FunctionDrawer.module.css';

const FunctionDrawer = ({
    connectorsClicked,
    ...props
}) => {

    return (
        <Paper className={classes.Drawer} style={{ 'marginTop': '2px' }}>
            <div className={classes.Column}>
                <div role="none" className={classes.CircleIcon} onClick={connectorsClicked}>
                    <button><i data-key="+" className="fas fa-plus" /></button>
                </div>
                <div role="none" className={classes.CircleIcon} onClick={connectorsClicked}>
                    <button><i data-key="-" className="fas fa-minus" /></button>
                </div>
                <div role="none" className={classes.CircleIcon} onClick={connectorsClicked}>
                    <button><i data-key="*" className="fas fa-times" /></button>
                </div>
                <div role="none" className={`${classes.CircleIcon} margin-25`} onClick={connectorsClicked}>
                    <button><i data-key="/" className="fas fa-divide" /></button>
                </div>
                <div role="none" className={`${classes.CircleIcon} margin-25`} onClick={connectorsClicked}>
                    <button><i data-key="%" className="fas fa-percent" /></button>
                </div>
                <div role="none" className={`${classes.CircleIcon} margin-25`} onClick={connectorsClicked}>
                    <button><i data-key="^" className="fas fa-chevron-up" /></button>
                </div>
            </div>
            <div className={classes.Column}>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Round</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Round Up</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Round Down</button>
                </div>
            </div>
            <div className={classes.Column}>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Square Root</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Absolute</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Log 10</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>e^x</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>10^x</button>
                </div>
            </div>
            <div className={classes.Column}>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Is Even</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Is Odd</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Is Prime</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Is Whole</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Is Positive</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Is Negative</button>
                </div>
            </div>
            <div className={classes.Column}>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Sum</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Min</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Max</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Average</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Median</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Modes</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Standard Deviation</button>
                </div>
                <div role="none" className={classes.FunctionButton} onClick={connectorsClicked}>
                    <button>Random Item</button>
                </div>
            </div>
        </Paper>
    );
};

export default FunctionDrawer;
